class LeasedCar {
	constructor(id, gameUserId, carId, startTurn, endTurn) {
		this.id = id;
		this.gameUserId = gameUserId;
		this.carId = carId;
		this.startTurn = startTurn;
		this.endTurn = endTurn;
	}

	toPlainObj() {
		return {
			id: this.id,
			gameUserId: this.gameUserId,
			carId: this.carId,
			startTurn: this.startTurn,
			endTurn: this.endTurn
		};
	}
}

export default function LeasedCarBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withGameUserId: function (gameUserId) {
			this.gameUserId = gameUserId;
			return this;
		},
		withCarId: function (carId) {
			this.carId = carId;
			return this;
		},
		withStartTurn: function (startTurn) {
			this.startTurn = startTurn;
			return this;
		},
		withEndTurn: function (endTurn) {
			this.endTurn = endTurn;
			return this;
		},
		build: function () {
			return new LeasedCar(
				this.id,
				this.gameUserId,
				this.carId,
				this.startTurn,
				this.endTurn
			);
		}
	};
}

export function CreateLeasedCarModel(car, carInfo) {
	const carLeaseInfo = new LeasedCarBuilder()
		.withId(car.id)
		.withGameUserId(car.game_user_id)
		.withCarId(car.car_id)
		.withStartTurn(car.start_turn)
		.withEndTurn(car.end_turn)
		.build().toPlainObj();

	return {
		...carLeaseInfo,
		slug: carInfo.slug,
		carName: carInfo.carName,
		price: carInfo.price,
		discountPercent: carInfo.discountPercent,
		description: carInfo.description
	};
}
